import React from "react";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import * as formViews from "./constants/formViews";
import { selectRegistrationAccount } from "../../../redux/slices/registrationAccountSlice";
import AccountPageContent from "./AccountPageContent";

const ConnectedAccountPageContent = () => {
    const {
        ENUMS: { Status },
    } = constants;
    const registrationAccount = useSelector(selectRegistrationAccount);
    const {
        form: { formView },
        resetPasswordLinkStatus = "",
    } = registrationAccount;
    // The form that contains the email, password, confirm password fields
    // and the corresponding submit button
    const displayAccountForm =
        formView === formViews.ACTIVATE_ACCOUNT ||
        formView === formViews.SIGN_IN ||
        (formView === formViews.RESET_PASSWORD &&
            resetPasswordLinkStatus === Status.ACTIVE);
    // The confirm password field only needs to be displayed to users who are
    // activating an account or resetting a password
    const displayConfirmPasswordField =
        formView === formViews.ACTIVATE_ACCOUNT ||
        (formView === formViews.RESET_PASSWORD &&
            resetPasswordLinkStatus === Status.ACTIVE);

    const accountPageContentProps = {
        displayConfirmPasswordField,
        displayAccountForm,
    };

    return <AccountPageContent {...accountPageContentProps} />;
};

export default ConnectedAccountPageContent;
